import type { AppEnvironment } from './types';
import { IP4CMS_PAGE_COPY } from './page-copy-ip4cms';

/**
 * Saldanha Bay Municipality — a single-community variant of the IP4CMS member
 * zone. Same regional stack as ip4cms; served from `dist/sbm` and wrapped as a
 * dedicated native app (com.sudosky.ip4cms.sbm). `defaultDomain` pins the app
 * to the Saldanha Bay tenant so launch resolves its branding directly (on
 * localhost / native shell, per `prefersConfiguredDomain`).
 */
export const env: AppEnvironment = {
  production: true,
  buildMode: 'sbm',
  apiBaseUrl: 'https://ip4x-za.sudosky.com/v1',
  coreApiUrl: 'https://ip4x-core-api.sudosky.com/v1',
  appTemplateId: '',
  authMode: 'core',
  portalOwnerType: 'member',
  loadDomainConfig: true,
  defaultDomain: 'saldanhabaymuni.ip4cms-member-za.ip4x.systems',
  rootTenantId: '',
  portalBaseUrl: 'https://ip4cms-member-za.ip4x.systems',
  appName: 'Saldanha Bay',
  version: '1.0.0',
  appShell: 'classic',
  keyboardShift: true,
  welcomeContent: {
    eyebrow: 'Saldanha Bay Municipality',
    title: 'Your community,\nin your pocket.',
    subtitle: 'Access and services in one place.',
  },
  communitySelectContent: {
    title: 'Choose your community',
    subtitle: 'Search for your community to continue.',
  },
  signupTermsUrl: 'https://www.glovent.co.za/terms',
  pageCopy: IP4CMS_PAGE_COPY,
  home: {
    widgetMode: true,
    widgets: [
      { id: 'support', type: 'support', title: 'Helpdesk', order: 1, enabled: true, requiresModule: 'support' },
      { id: 'events', type: 'events', title: 'Upcoming events', order: 2, enabled: true, requiresModule: 'events' },
      { id: 'panic', type: 'panic', title: 'Emergency', order: 3, enabled: true, requiresModule: 'panic' },
      { id: 'utilities', type: 'utilities', title: 'Utilities', order: 4, enabled: true, requiresModule: 'utilities' },
    ],
  },
};
